import { render, staticRenderFns } from "./form.vue?vue&type=template&id=0ea876fa&scoped=true"
import script from "./form.vue?vue&type=script&lang=js"
export * from "./form.vue?vue&type=script&lang=js"
import style1 from "./form.vue?vue&type=style&index=1&id=0ea876fa&prod&lang=css"
import style2 from "./form.vue?vue&type=style&index=2&id=0ea876fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea876fa",
  null
  
)

export default component.exports